import * as React from "react";
import { Navigate, Outlet } from "react-router";

import { useAuthenticatedUser } from "@/hooks/use-authenticated-user";
import type { OrganizationFeature } from "@/types/organization";

interface Props {
  feature: OrganizationFeature;
}

export const OrganizationFeatureRouteGate: React.FC<Props> = ({ feature }) => {
  const user = useAuthenticatedUser();

  if (user.isLoading || !user.isAuthenticated) return null;
  if (!user.organization.features.includes(feature)) return <Navigate to="/drive" replace />;

  return <Outlet />;
};
